import { useEffect, useState } from "react"

import { ContentObjectItem, ContentObjectStatus } from "@vertesia/common"
import { Trash2 } from "lucide-react"

import { ActionTooltipButton } from "@components/buttons/ActionTooltipButton"

import { useUserSession } from "@session/UserSession"

import { Badge } from "@ui/badge"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/tooltip"

const INTERVAL_TIMER = 10000

interface FileSelectedButtonProps {
    document: ContentObjectItem
    onRemove: (document: ContentObjectItem) => void
}
export function FileSelectedButton({ document, onRemove }: FileSelectedButtonProps) {
    const { client } = useUserSession()

    const [documentName, setDocumentName] = useState("")
    const [status, setStatus] = useState("")
    const [color, setColor] = useState("grey")
    const [blinking, setBlinking] = useState(false)

    const retrieveDocumentStatus = () => {
        if (!client) {
            return
        }

        client.objects.retrieve(document.id).then((doc) => {
            if (!documentName || documentName === "") {
                setDocumentName(doc.name)
            }

            const completed = doc.status === ContentObjectStatus.completed
            setStatus(doc.status)
            setColor(completed ? "green" : "orange")
            setBlinking(!completed)

            if (!completed) {
                setTimeout(retrieveDocumentStatus, INTERVAL_TIMER)
            }
        })
    }

    useEffect(() => {
        retrieveDocumentStatus()
    }, [document, client])

    return (
        <Badge variant="outline" className="p-1 flex-shrink-0 flex items-center gap-2 bg-gray-100">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger className="text-primary">
                        <span className={`ml-2 size-2 rounded-full inline-block ${blinking ? "animate-pulse" : ""}`} style={{ backgroundColor: color }} />
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>{status}</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
            {documentName || document.id}
            <ActionTooltipButton icon={<Trash2 />} tooltip="Remove File" variant="ghost" size="icon" onClick={() => onRemove(document)} />
        </Badge>
    )
}
